import { observer, useLocalObservable } from 'mobx-react-lite'
import React from 'react'
import { Alert, Button } from 'shared/ui'
import { DefaultModalActions } from 'shared/ui/Modal/ui/DefaultModal/DefaultModalActions.tsx'
import { type IAgentHandoffNotifySettings } from 'entities/Chatbot'
import type { AgentInstructionsStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/store/AgentInstructionsStore.tsx'
import { HandoffNotifySettings } from 'pages/chatbot/ui/ChatbotEdit/StepHandoff/ui/HandoffNotifySettings/HandoffNotifySettings.tsx'
import { HandoffNotifySettingsStore } from 'pages/chatbot/ui/ChatbotEdit/StepHandoff/ui/HandoffNotifySettings/store/HandoffNotifySettingsStore.ts'
import styles from './styles.module.scss'

export type IHandoffToHumanContentProps = {
  onClose: () => void
  onSave: AgentInstructionsStore['onAddHandoffToHumanAction']
  onDelete?: () => void
  data?: IAgentHandoffNotifySettings
}

export const HandoffToHumanContent = observer(
  ({ onClose, onSave, data, onDelete }: IHandoffToHumanContentProps) => {
    const store = useLocalObservable(() => new HandoffNotifySettingsStore(data))

    const handleSave = () => {
      const validError = store.validate()
      if (validError) {
        return
      }
      onSave(store.notifySettings)
      onClose()
    }
    const handleDelete = () => {
      onDelete?.()
      onClose()
    }

    return (
      <>
        <div className={styles.content}>
          <HandoffNotifySettings store={store} />
          {store.error && (
            <Alert
              item={{
                type: 'error',
                desc: store.error,
              }}
            />
          )}
        </div>

        <DefaultModalActions>
          {onDelete && (
            <Button
              style={{ marginRight: 'auto' }}
              typeBtn={'contained'}
              text={'Delete action'}
              size={'medium'}
              contained={'secondary'}
              intent={'destructive'}
              onClick={handleDelete}
            />
          )}
          <Button
            typeBtn={'contained'}
            text={'Cancel'}
            size={'medium'}
            contained={'secondary'}
            onClick={onClose}
          />
          <Button
            typeBtn={'contained'}
            text={'Save'}
            size={'medium'}
            contained={'primary'}
            onClick={handleSave}
          />
        </DefaultModalActions>
      </>
    )
  }
)
